// ============================================================================
// CONSENT WORDING SERVICE (Frontend)
// Versions of the Session Hub consent text (Admin > Consent Wording).
// ============================================================================

import { api } from './api';

export type ConsentTemplateStatus = 'draft' | 'approved' | 'retired';

export interface ConsentTemplateText {
  attendeeText: string;
  sponsorText: string;
  dietaryText: string;
  processorList: string[];
}

export interface ConsentTemplate extends ConsentTemplateText {
  version: number;
  status: ConsentTemplateStatus;
  textSha256?: string;
  copiedFrom?: number;
  createdAt: string;
  updatedAt: string;
  approvedAt?: string;
  retiredAt?: string;
}

const base = '/api/admin/consent-templates';

export const consentTemplatesService = {
  async list(): Promise<{ templates: ConsentTemplate[]; approvedVersion: number | null }> {
    const { data } = await api.get<{ templates: ConsentTemplate[]; approvedVersion: number | null }>(base);
    return data;
  },

  async create(body: Partial<ConsentTemplateText> & { copyFrom?: number } = {}): Promise<ConsentTemplate> {
    const { data } = await api.post<{ template: ConsentTemplate }>(base, body);
    return data.template;
  },

  async update(version: number, body: Partial<ConsentTemplateText>): Promise<ConsentTemplate> {
    const { data } = await api.put<{ template: ConsentTemplate }>(`${base}/${version}`, body);
    return data.template;
  },

  async approve(version: number): Promise<ConsentTemplate> {
    const { data } = await api.post<{ template: ConsentTemplate }>(`${base}/${version}/approve`);
    return data.template;
  },

  async retire(version: number): Promise<ConsentTemplate> {
    const { data } = await api.post<{ template: ConsentTemplate }>(`${base}/${version}/retire`);
    return data.template;
  },
};

/** Same substitution the server uses for {{deletionDate}}. */
export const renderConsentText = (text: string, deletionDate: string) =>
  text.replace(/\{\{\s*deletionDate\s*\}\}/g, deletionDate);
